import { useState } from "react";
import { MdSearch, MdNotifications, MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./SalesHeader.css";

const ITEMS = ["snake", "background", "powerup", "chest"];

const FILTERS = {
  snake: ["All", "Basic", "Pattern", "Animals", "Theme"],
  background: ["All", "Basic", "Premium"],
  // powerup: ["All", "Magnet", "Speed"],
  powerup: ["All"],
  chest: ["All"],
};

export default function SalesHeader({
  activeView,
  selectedFilter,
  onFilterChange,
  onViewChange,
  searchText,
  onSearchChange,
}) {
  const [open, setOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();

  const handleSelectItem = (item) => {
    onViewChange(item);
    setOpen(false);
  };

  return (
    <div className="sales-header">
      <div className="header-content">
        {/* TOP */}
        <div className="header-top">
          <div className="search-desktop">
            <MdSearch />
            <input
              value={searchText}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search..."
            />
          </div>

          <button className="search-mobile" onClick={() => setShowSearch(true)}>
            <MdSearch />
          </button>

          <div className="notification">
            <MdNotifications />
          </div>
        </div>

        {showSearch && (
          <div className="mobile-search">
            <div className="mobile-search-box">
              <MdSearch />
              <input
                autoFocus
                value={searchText}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder="Search..."
              />
              <button onClick={() => setShowSearch(false)}>
                <MdClose />
              </button>
            </div>
          </div>
        )}

        {/* BOTTOM */}
        <div className="header-bottom">
          <div>
            <h1>Sales & Inventory</h1>
            <p>Add & manage products</p>
          </div>

          <div className="controls">
            <button
              className="coins-btn"
              onClick={() => navigate("/layout/Sales")}
            >
              Sales
            </button>

            <button
              className="coins-btn"
              onClick={() => navigate("/layout/coins")}
            >
              Coins
            </button>

            {/* FIXED DROPDOWN */}
            {activeView === "sales" ? (
              <>
                <button
                  className="dropdown-btn"
                  onClick={() => setOpen((prev) => !prev)}
                >
                  Select Item ▼
                </button>

                {open && (
                  <div className="fixed-dropdown">
                    {ITEMS.map((item) => (
                      <button key={item} onClick={() => handleSelectItem(item)}>
                        {item.charAt(0).toUpperCase() + item.slice(1)}
                      </button>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <select
                value={selectedFilter}
                onChange={(e) => onFilterChange(e.target.value)}
              >
                {FILTERS[activeView].map((f) => (
                  <option key={f} value={f}>
                    {f}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
